module.exports = __webpack_public_path__ + "8573067e6ed376ee59bc1506ec7fade6.svg";